import React from 'react';
import { History, actionTypes, alfrescoTypes, attachmentStatuses, documentBpActions, permissionTypes, documentStatuses, formFieldTypes, formModes, statutoryDocTypes, searchTableTypes, alfrescoRoles, allowedAdditionalFileExtensions, acceptAdditionalInputFileString, counterpartyDocKinds } from '../../constants';
import { buildFormField, getFormSection, getFormSectionSettings, padWithZeroes, InputContainer } from '../form/Form';
import { AttachmentForm } from './attachments/AttachmentForm';
import { CommentForm } from '../comments/CommentForm';
import { buildComentAction } from '../comments/Comment';
import { SignForm } from '../forms/SignForm';
import { StatutoryDocsForm } from '../forms/StatutoryDocsForm';
import * as HelperFunctions from '../helpers/HelperFunctions';
import * as ModalDialogsTemplates from '../ModalDialog';
import * as ModalDialog from '../ModalDialog';
import { Svg } from '../Svg';
import { DocumentInfo } from './DocumentInfo';
import { InfoBtnControl } from '../InfoBtnControl';
import { documentTabs, statuses } from './Document';
import * as ListOfContracts from '../listsOfAlfresco/ListOfContracts';
import * as ListOfUsersTaskExecuters from '../listsOfAlfresco/ListOfUsersTaskExecuters';
import { ListOfAlfresco } from '../listsOfAlfresco/ListOfAlfresco';
import { Table } from '../table/Table';
import { clientSettings } from '../../settings/clientSettings';
import { DynamicForm } from './DynamicForm';
import * as ListOfDocuments from '../listsOfAlfresco/ListOfDocuments';
import i18n from '../../i18n';
import { v4 } from 'uuid';
import { globalEventDispatcher, dispatcherActionTypes } from '../helpers/GlobalEventDispatcher';

const mime = require("mime-types");

export const getFile = async (id, type, asZip = false, withSign = false) => await fetch(`file/${type === alfrescoTypes.counterparties ? "GetXml" : `get${asZip ? "Zip" : ""}`}?nodeRefs=${id.split('/').pop()}&withSign=${withSign}`, { method: 'post', headers: { 'Content-Type': 'application/json' } }).then(async (reponse) => (await reponse.json())[0]);

export async function downloadFile(id, title = "", type = "", asZip = false, withSign = false) {
	try {
		var data = await getFile(id, type, asZip, withSign);
		if (data.content) {
			let fileExtension = '.' + mime.extension(data.mimeType);
			if (title && !title.toLowerCase().endsWith(fileExtension)) {
				title += fileExtension;
			}
			if (!data.fileName && title) {
				data.fileName = title;
			}
			if (!data.fileName) {
				data.fileName = "document" + fileExtension;
			}
			if (!data.fileName.toLowerCase().endsWith(fileExtension)) {
				data.fileName += fileExtension;
			}
			downloadContent(data, title);
			return true;
		}
	}
	catch (e) {
		console.error('Get file error');
	}
	return false;
}
export const downloadSign = async(id, title = "") => downloadContent(await (await fetch(`/file/Signs?id=${id}`, { method: 'post', headers: { 'Content-Type': 'application/json' } })).json(), title);
export function downloadContent(data, title) {
	try {
		let fileExtension = '.' + mime.extension(data.mimeType);
		if (!title) {
			title = data.fileName;
		}
		if (!title.endsWith(fileExtension)) {
			title += fileExtension;
		}

		let anchor = document.createElement("a");
		anchor.href = `data:${data.mimeType};base64,${data.content}`;
		anchor.download = title;
		anchor.click();
	} catch (e) { ModalDialogsTemplates.errorMessageDialog('1'); }
}
export async function getComents() {
	ModalDialog.hideModalDialog('modalDialog');
	const { prop_sys_node_uuid } = this.state;
	if (prop_sys_node_uuid) this.setState({ comments: await buildComentAction('GET', `comments/get/${prop_sys_node_uuid}`) });
}
export async function addComment(comment) {
	const { prop_sys_node_uuid } = this.state;
	if (prop_sys_node_uuid) await buildComentAction('POST', 'comments/crud', {
		action: 'addComment',
		content: comment.content,
		documentNodeRef: prop_sys_node_uuid,
	});
	else this.setState({ comments: [...this.state.comments, comment] })
	getComents.bind(this)()
}
export async function getFormSetting(type) {
	const response = await fetch(`Document/Form/${type}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
	if (response.ok) return await response.json();
	handleGetDocumentError(response.status);
}
export function getFormFields() {
	const { form, prop_sx_dfState, removedDocuments } = this.state;
	let result = {};
	for (let i = 0; i < form?.Fields?.length; ++i) {
		if (!form.Fields[i].Ignore && (!form.Fields[i].IgnoreWhile || form.Fields[i].IgnoreWhile.indexOf(prop_sx_dfState) === -1)) {
			let { Name, Type } = form?.Fields[i];
			let fieldValue = this.state[Name];
			if (fieldValue && Type === formFieldTypes.datetime) {
				if (fieldValue.includes("T")) {
					let date = HelperFunctions.getLocalDateString(new Date(fieldValue)).split(".");
					fieldValue = `${date[2]}-${date[1]}-${date[0]}`;
				}
				else {
					fieldValue = fieldValue.split("-");
					fieldValue = `${padWithZeroes(fieldValue[0], 4)}-${fieldValue[1]}-${fieldValue[2]}`;
				}
			}
			result[Name] = (fieldValue || Type === formFieldTypes.bool) ? fieldValue : (Type === formFieldTypes.datetime ? null : "");
		}
	}
	if (removedDocuments && removedDocuments.length > 0) {
		result.assoc_sx_additionalFiles_removed = removedDocuments.join(',');
	}
	return result;
}
export function handlerCloseDocument(pathname) {
	const { formMode, type } = this.state;
	if ((type && (pathname?.toLowerCase() !== window.location.pathname.toLowerCase())) || !pathname) {
		if (formMode !== formModes.read) {
			let closeDialog = () => ModalDialog.hideModalDialog('modalDialog');
			let handlerCloseCreateForm = function () {
				closeDialog();
				if (pathname) {
					History.block(true);
					History.push(pathname);
				}
				else window.location.replace("/");
			}
			ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{i18n.t("ifNeedSaveMessage")}</div>, "feedPopup", true, [{ title: i18n.t("save"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog'); this.actionHandlerCallback(actionTypes.save); }, class: "btn-primary" }, { title: "Не зберігати", clickHandler: () => formMode === formModes.create ? handlerCloseCreateForm() : (() => window.location.reload())(), class: "btn-secondary" }, { title: i18n.t("cancel"), clickHandler: closeDialog, class: "btn-secondary" }], () => closeDialog());
		}
		else History.push(alfrescoTypes.counterparties === type ? '/' : '/documents');
		return false
	}
	return true;
}
export function handleChangeRelatedDocuments(type = '', rows = []) {
	switch (type) {
		case actionTypes.add:
		case actionTypes.remove:
			this.state["assoc_sx_relatedDocuments_" + (actionTypes.add ? "added" : "removed")] = rows.map((item) => "workspace://SpacesStore/" + item.columns.Id).join(',');
			break;
	}
	this.actionHandlerCallback(actionTypes.save);
}
export async function addFile(e) {
	e.persist();
	if (ModalDialogsTemplates.isValidFileSizeDialog(e.target.files[0].size))
		this.setState({
			additionalDocuments: [...this.state.additionalDocuments, { id: (new Date().getTime()).toString(), file: e.target.files[0], fileName: e.target.files[0]?.name }]
		});
	e.target.value = null;
}
export async function handleGetDocumentError(code) {
	switch (code) {
		case 404: History.replace("/404"); break;
		default: require('../ModalDialog').unknownErrorMessageDialog(window.location.pathname + window.location.search); break;
	}
}
export async function signDocument(ids = []) {
	const { type, prop_sys_node_uuid, attachments } = this.state;
	ids.push(...(attachments ? attachments?.filter(item => item?.nodeRef && item.state !== attachmentStatuses.noDoc)?.map(item => item.nodeRef) : []));
	let handlerResult = function (isSuccessResult = true) {
		if (isSuccessResult) {
			let onClodeHandler = function () {
				ModalDialog.hideModalDialog('modalDialog');
				window.location.reload();
			}
			ModalDialog.showModalDialog('modalDialog', i18n.t("done"), "", <div className="info-message">{i18n.t("Документ успішно підписано")}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: onClodeHandler, class: "btn-primary" }], onClodeHandler);
		}
	}
	await signFiles.bind(this)(ids.concat(type !== alfrescoTypes.counterparties ? [prop_sys_node_uuid] : []), {}, handlerResult, false, false, type === alfrescoTypes.contract || type === alfrescoTypes.universalContract);
}
export async function signFiles(ids = [], body = {}, handlerResult = null, withoutStamp = false, withoutSign = false, isSingleFile) {
	let fielesContent = await getFilesContentForSigning(ids);
	if (!fielesContent) {
		return require('../ModalDialog').unknownErrorMessageDialog();
	}

	let onSignHandler = async function (signs) {
		if (await checkActionPermission.bind(this)(permissionTypes.sign)) {
			let isSuccessResult = true;
			for (let j = 0; j < signs.length; ++j) {
				isSuccessResult = await submitSignedFile(signs[j], isSingleFile);
			}
			if (!isSuccessResult) require('../ModalDialog').unknownErrorMessageDialog();
			if (handlerResult) handlerResult(isSuccessResult);
		}
	}
	ModalDialog.showModalDialog('modalDialog', i18n.t("digitalSignature"), "", <SignForm files={fielesContent} handlerRestart={() => {
		handlerResult(false);
		signFiles.bind(this)(ids, body, handlerResult, withoutStamp, withoutSign);
	}} onSignHandler={onSignHandler.bind(this)} onCloseHandler={() => { ModalDialog.hideModalDialog('modalDialog'); handlerResult(false); }} withoutStamp={withoutStamp} withoutSign={withoutSign} />, "feedPopup middle-size", true, [], () => {
		handlerResult(false);
		ModalDialog.hideModalDialog('modalDialog');
	});
}
export async function submitSignedFile(sign, isSingleFile) {
	let result = true;
	let requestOptions = { method: 'post', headers: { 'Content-Type': 'application/json' } };

	requestOptions.body = JSON.stringify(sign.value);
	let response = await fetch(`File/AddSignature?id=${sign.id}`, requestOptions);
	if (!response.ok) {
		result = false;
	}
	else if (!isSingleFile) {
		requestOptions.body = JSON.stringify({ properties: { state: attachmentStatuses.Signed }, currentElementNodeRef: `workspace://SpacesStore/${sign.id.split("/").pop()}`, assocName: "sx:additionalFiles" });
		let response = await fetch(`Document/EditAdditionalFiles`, requestOptions);
		if (!response.ok) {
			result = false;
		}
	}
	return result;
}
export async function documentActionHandlerCallback(actionType, actionRequest) {
	const { prop_sys_node_uuid, type } = this.state;
	let checkInputValues = () => {
		if (this.checkInputPage) {
			const checkResult = this.checkInputPage();
			if (checkResult.error) {
				showCheckFailedMessage.bind(this)(checkResult);
				return false;
			}
		}
		return true;
	}
	let currentObject = this;
	this.setState({ submitted: true });
	switch (Number(actionType)) {
		case actionTypes.invoice: window.location.replace(`/content/sx:Invoice?parent=${prop_sys_node_uuid}`);
		case actionTypes.score: window.location.replace(`/content/sx:score?parent=${prop_sys_node_uuid}`);
		case actionTypes.cancel: handlerCloseDocument.bind(this)(); break;
		case actionTypes.edit: {
			if (await checkActionPermission.bind(this)(permissionTypes.edit)) {
				return this.setState({ formMode: formModes.edit });
			}
			return;
		}
		case actionTypes.changeTaslExecuter: return ModalDialog.showModalDialog("loadingDialog", i18n.t("14"), "", <ListOfAlfresco prop_sys_node_uuid={prop_sys_node_uuid} parentComponent={ListOfUsersTaskExecuters} type={searchTableTypes.Users} />, "feedPopup middle-size");
		case actionTypes.reject: return ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{i18n.t("rejectDocumentMessage")}</div>, "feedPopup", true, [{ title: i18n.t("yes"), clickHandler: () => currentObject.actionHandlerCallback(actionTypes.save, actionType), class: "btn-primary" }, { title: i18n.t("no"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog') }, class: "btn-secondary" }]);
		case actionTypes.save:
			if (checkInputValues())
				await handleSubmit.bind(this)(actionRequest ? actionRequest : "");
			break;
		case actionTypes.annul: return ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{i18n.t("cancelDocumentMessage")}</div>, "feedPopup", true, [{ title: i18n.t("yes"), clickHandler: () => currentObject.actionHandlerCallback(actionTypes.save, actionRequest), class: "btn-primary" }, { title: i18n.t("no"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog') }, class: "btn-secondary" }]);
		case actionTypes.sign:
			if (await checkActionPermission.bind(this)(permissionTypes.sign)) {
				if (checkInputValues()) {
					if (type === alfrescoTypes.counterparties && !this.checkAttachmentsMandatoryAdding()) {
						ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{i18n.t("notAllFileAdded")}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: () => { this.setState({ activeTab: documentTabs.docs }); ModalDialog.hideModalDialog('modalDialog') }, class: "btn-primary" }], () => this.setState({ activeTab: documentTabs.docs }));
					}
					else signDocument.bind(this)();
				}
			}
			return;
			break;
	}
}
export async function deleteDocument(id) {
	await fetch(`Document/Delete?id=${id}`, { method: "DELETE" })
		.then(res => {
			if (!res.ok) require('../ModalDialog').unknownErrorMessageDialog();
		});
}
export function buildFormSection(sectionName) {
	const { form, submitted, formMode, type } = this.state;
	let section = getFormSection(form, sectionName);
	let sectionSettings = getFormSectionSettings(form, sectionName);
	let sectionItems = section.sectionItems;
	if (sectionItems) {
		let fields = [];
		for (let i = 0; i < sectionItems.length; ++i) {
			let item = JSON.parse(JSON.stringify(sectionItems[i]));
			if (item?.Name) item.Value = item.Name.split('+').map(value => this.state[value]).join(' ');
			item = this?.buildFormItem ? this.buildFormItem.bind(this)(item) : item;
			if (item && item.Name === 'prop_sx_ContractExpireStart' && type === alfrescoTypes.universalContract && this.state.prop_sx_AgreementKind !== 'A40601') {
				item = null;
			}
			if (item) {
				fields.push(item);
				let indexFieldConfiguration = form.Fields.findIndex((field) => field.Name === item.Name);
				if (indexFieldConfiguration !== -1) {
					form.Fields[indexFieldConfiguration].Ignore = form.Fields[indexFieldConfiguration].Ignore || fields.findIndex((field) => field?.Name === item?.Name) === -1 || item.Type === formFieldTypes.empty;
					item.Disabled = formMode === formModes.read ? true : item.Disabled;
					item.Check = submitted || formModes.edit === formMode;
				}

				if (type === alfrescoTypes.counterpartyDoc && item?.Name === 'prop_sx_caDocKind' && formMode !== formModes.create) {
					item.Disabled = true;
				}
				if (item.Name === 'prop_sx_Storage' && type === alfrescoTypes.universalContract && this.state.prop_sx_AgreementKind === 'A40601') {
					item.Label.Label = i18n.t("others.A40601ExecutorLabel");
				}
				if (item.Name === 'prop_sx_ContractExpireEnd' && type === alfrescoTypes.universalContract && this.state.prop_sx_AgreementKind === 'A40601') {
					item.Label.Label = i18n.t("others.A40601ExpireEndLabel");
				}
			}
		}
		if (type === alfrescoTypes.universalContract && this.state.prop_sx_AgreementKind === 'A40601') {
			const storageField = fields.find(f => f.Name === 'prop_sx_Storage');
			const startDateFieldIndex = fields.findIndex(f => f.Name === 'prop_sx_ContractExpireStart');
			if (storageField && startDateFieldIndex >= 0) {
				fields = fields.filter(f => f.Name !== 'prop_sx_Storage');
				fields.splice(startDateFieldIndex, 0, storageField);
			}
		}
		return (
			<>
				{sectionSettings?.Label?.Label ?
					<div className="form-group col-sm-12 col-xs-12">
						<label className="header-label">{sectionSettings?.Label?.Label}</label>
					</div> :
					""
				}
				{fields.map((item) =>
					<div key={item?.Name} name={item.Name} className={'form-group col-sm-' + item.Columns + ' col-xs-' + item.Columns + ' field-' + item.Type} >
						<InputContainer {...item}>{buildFormField(item, HelperFunctions.changeInputValue.bind(this))}</InputContainer>
					</div>
				)}
			</>
		);
	}
	return ([]);
}
export function onSignerSubmit(props) {
	if (!props.Id) {
		props.added = true;
		props.Id = v4();
	}
	else {
		props.updated = true;
	}
	this.setState(prevState => {
		const signatories = prevState.cpAuthorityPersons;
		if (props.added) {
			signatories.push(props);
		}
		else if (props.updated) {
			const signatory = signatories.find(s => s.Id === props.Id);
			Object.assign(signatory, props);
		}
		return {
			cpAuthorityPersons: signatories,
		};
	});
	console.log(props);
}
export function onSignerRemove(props) {
	const removed = this.state.cpAuthorityPersons.find(s => s.Id === props.Id);
	if (!removed.added) {
		this.setState(prevState => {
			const removedSignatories = prevState.removedSignatories ?? [];
			removedSignatories.push(props.Id);
			return {
				cpAuthorityPersons: this.state.cpAuthorityPersons.filter(s => s.Id !== props.Id),
				removedSignatories
			};
		});
	}
	else {
		this.setState({
			cpAuthorityPersons: this.state.cpAuthorityPersons.filter(s => s.Id !== props.Id)
		});
	}
}
export function renderFormHeader() {
	const { prop_sys_node_uuid, prop_cm_title, formMode, prop_sx_dfState, isPerformer, type, settings, externalSigners, mimetype, associations, form, prop_sx_grainStorage, showGrainStorageInfo } = this.state;
	let btns = {
		download: { src: "icn-download.svg", title: i18n.t("download"), onClick: () => downloadFile(associations.mainContent[0], prop_cm_title, type, false, false) },
		view: { src: "download.svg", title: i18n.t("view"), onClick: () => ModalDialogsTemplates.viewPdfDialog(associations.mainContent[0]), show: "application/pdf" === mimetype || "application/octet-stream" === mimetype },
		downloadWithSign: { src: "icn-sign1.svg", title: i18n.t("25"), onClick: () => downloadFile(associations.mainContent[0], prop_cm_title, "", false, true) },
		downloadSign: { src: "icn-sign1.svg", title: i18n.t("26"), onClick: () => downloadSign(associations.mainContent[0], prop_cm_title) },
		downloadTemplate: { src: "icn-download.svg", title: i18n.t("downloadTemplate"), onClick: () => ModalDialog.showModalDialog('modalDialog', i18n.t(i18n.t("downloadDocumentTemplate")), "", <StatutoryDocsForm key={statutoryDocTypes.template} docType={statutoryDocTypes.template} canEdit={false} inPopup={false} />, "feedPopup middle-size") },
		newConnection: { src: "sep.svg", title: i18n.t("addConnection"), onClick: () => ModalDialog.showModalDialog('modalDialog', i18n.t("addNewConnection"), "", <ListOfAlfresco parentComponent={ListOfContracts} withAction={false} type={searchTableTypes.Documents} additionalFilter={[{ "DocType": [] }]} actionHandlerCallback={handleChangeRelatedDocuments.bind(this)} />, "feedPopup middle-size") },
		addComment: { src: "icn-comadd.svg", title: i18n.t("addComment"), onClick: () => ModalDialog.showModalDialog('modalDialog', i18n.t("addComment"), "", <CommentForm documentId={prop_sys_node_uuid} handleChangeComment={addComment.bind(this)} />, "feedPopup") },
		getComents: { classes: "has-additionnal-btn", src: "icn-refresh.svg", title: i18n.t("update"), onClick: getComents.bind(this) },
		youControlRequest: { src: "refresh.svg", title: i18n.t("fillWithYouControl"), onClick: this.youControlRequest },
		transliterate: { src: "transliteration.svg", title: i18n.t("fieldsTransliteration"), onClick: this.transliterate },
		addBank: { src: "users.svg", title: i18n.t("addBank"), onClick: () => ModalDialog.showModalDialog('modalDialog', i18n.t(i18n.t("19")), "", <DynamicForm path='Bank' />, "feedPopup  middle-form") },
		addSigner: {
			src: "users.svg", title: i18n.t("31"),
			onClick: () => ModalDialog.showModalDialog('modalDialog', i18n.t(i18n.t("31")), "",
				<DynamicForm path='cpSignatory'
					onSubmit={formMode !== formModes.read ?
						(formProps) => {
							onSignerSubmit.bind(this)(formProps);
						} : null} />,
				"feedPopup  middle-form")
		},
		addAttacment: {
			src: "icn-addatach.svg", title: i18n.t("addDocument"),
			onClick: () => ModalDialog.showModalDialog('modalDialog', i18n.t("addDocument"), "",
				<AttachmentForm typesOfDocumens={this.getCurAttacmentsTypes.bind(this)()} onCloseHandler={() => { ModalDialog.hideModalDialog('modalDialog'); }} />, "feedPopup middle-form")
		}
	};
	let tabName = HelperFunctions.getUrlParam("tab")?.toLowerCase();
	let activeBtns = documentTabs.comments === tabName ? [btns.addComment] : [];
	if (type === alfrescoTypes.counterparties && [statuses.preparing, statuses.revision, statuses.rejected].indexOf(prop_sx_dfState) !== -1) {
		if (documentTabs.signers === tabName) activeBtns.push(btns.addSigner);
	}

	switch (formMode) {
		case formModes.create: case formModes.edit: break;
		case formModes.read:
			if (type === alfrescoTypes.counterparties && [statuses.preparing, statuses.revision, statuses.rejected].indexOf(prop_sx_dfState) !== -1) {
				if (documentTabs.financialinfo === tabName) activeBtns.push(btns.addBank);
			}
			if (documentTabs.docs === tabName && (prop_sx_dfState === statuses.preparing || prop_sx_dfState === statuses.revision)) activeBtns.push(btns.addAttacment);
			if (type !== alfrescoTypes.counterparties) {
				activeBtns.push(btns.view, btns.download);
				if (externalSigners?.length > 0) {
					activeBtns.push(btns.downloadWithSign, btns.downloadSign);
				}
			}
			break;
	}
	if (documentTabs.comments === tabName && formMode !== formModes.create) activeBtns.push(btns.getComents);
	let actions = settings.actions.filter((item) =>
		item.type == actionTypes.cancel ||
		(
			isPerformer &&
			((item?.statuses)?.includes(prop_sx_dfState) || (item?.statuses)?.includes(documentStatuses?.All)) &&
			((item?.modes)?.includes(formMode) || (item?.modes)?.includes(formModes.all) || item?.modes === null && formModes.read === formMode)
		)
	);
	if ((prop_sx_dfState === documentStatuses?.project || prop_sx_dfState === documentStatuses?.refinementCounterparty) && JSON.parse(localStorage.getItem('user')).role === alfrescoRoles.MODERATOR && formMode === formModes.read) actions.splice(actions.length - 1, 0, settings.actions.find((item) => item.type === actionTypes.changeTaslExecuter));

	let showRequestDocsSwitcher = tabName === documentTabs.docs && (prop_sx_dfState === statuses.preparing || prop_sx_dfState === statuses.revision);

	return (
		<>
			<div className="buttons-block-header">
				<ul>
					{actions.map((item) => (
						<li key={v4()}>
							<button onClick={() => { if (item?.type) this.actionHandlerCallback(item.type, item.action) }} className={"btn " + item.btnclass}>
								{item.title}
							</button>
						</li>
					))}
					<DocumentInfo {...this.state} />
				</ul>
			</div>
			<div style={{ display: activeBtns.length === 0 ? "none" : "" }} className="filter-block-header">
				<ul className="filter-header-buttons">
					{activeBtns.map((item) =>
						<li key={v4()} className={item?.classes ? item.classes : ""} style={{ display: item?.show === true || item?.show === undefined ? '' : 'none' }}>
							<button type="button" className="btn no-bg-btn" onClick={item?.onClick}><Svg src={`/img/${item.src}`} /><span>{item.title}</span></button>
						</li>)}
					{showRequestDocsSwitcher &&
						<li key={v4()} className="filter-header-check">
							<input id="prop_sx_grainStorage" name="prop_sx_grainStorage" onChange={grainStorageChanged.bind(this)} checked={prop_sx_grainStorage?.toString().toLowerCase() === 'true'} class="form-control" type="checkbox" />
							<label for="prop_sx_grainStorage">{i18n.t("grainStorageLabel")}</label>
							<InfoBtnControl show={showGrainStorageInfo} infoText={i18n.t("grainStorageLabelInfo")} />
						</li>
					}
				</ul>
			</div>
			<div className="form-block doc-form pb-0"><div className="form-content"><div dangerouslySetInnerHTML={{ __html: (formMode in (form.Messages ?? {})) ? form.Messages[formMode] : "" }} ></div></div></div>
		</>
	);
}

function grainStorageChanged(e) {
	let { checked } = e.target;
	if (e.target) {
		this.setState({ prop_sx_grainStorage: checked }, () => executeSubmitRequest(this.state, '', getFormFields.bind(this)()).then((response) => {
			if (response.ok) {
				fetch(`Document/GetAttachmentTypes?grainStorage=${checked}`).then(async (response) => {
					if (response.ok) {
						const responseText = await response.text();
						const attachmentTypes = JSON.parse(responseText.replaceAll('sxd:', ''));
						this.setState({ attachmentTypes: attachmentTypes, showGrainStorageInfo: checked }, () => this.fillNotAddedAttachments());
					}
					else window.location.reload();
				})
					.catch(() => window.location.reload());
			}
			else if (response.status === 422) {
				require('../ModalDialog').errorMessageDialog(i18n.t("4"));
				this.setState({ prop_sx_grainStorage: !checked, showGrainStorageInfo: false });
			}
			else {
				handleGetDocumentError(response.status);
				this.setState({ prop_sx_grainStorage: !checked, showGrainStorageInfo: false });
			}
		}));
	}
}

function showCheckFailedMessage(checkResult) {
	const currentObject = this;
	ModalDialog.showModalDialog("modalDialog", i18n.t("attentionTitle"), "",
		<div className="info-message">{checkResult.error}</div>,
			"feedPopup", true,
		[{ title: i18n.t("ok"), clickHandler: () => { ModalDialog.hideModalDialog('modalDialog'); onCheckFailedMessageClose.bind(currentObject)(checkResult.incorrectTab); }, class: "btn-primary" }],
			() => onCheckFailedMessageClose.bind(currentObject)(checkResult.incorrectTab)
		);
}

function onCheckFailedMessageClose(errorTab) {
	this.setState({ activeTab: errorTab });
}

export async function handleSubmit(action) {
	const { prop_sys_node_uuid, type, externalSigners } = this.state;

	let message;
	if (type === alfrescoTypes.counterparties && [documentBpActions.activitiprocessAccreditationCA, documentBpActions.completeCounterpartyCorrections, documentBpActions.activiti$completeContractsSigning].indexOf(action) !== -1) {
		let message = !this.checkAttachmentsMandatoryAdding() ? i18n.t("22") : (!this.checkAttachmentsMandatorySigning() ? i18n.t("22") : "");
		if (message)
			return ModalDialog.showModalDialog('modalDialog', i18n.t("attentionTitle"), "", <div className="info-message">{message}</div>, "feedPopup", true, [{ title: i18n.t("ok"), clickHandler: () => { this.setState({ activeTab: documentTabs.docs }); ModalDialog.hideModalDialog('modalDialog') }, class: "btn-primary" }], () => this.setState({ activeTab: documentTabs.docs }));
	}
	else if (!externalSigners && action && (action !== documentBpActions.activiti$returnContractToCorrections)) return require('../ModalDialog').errorMessageDialog(i18n.t("1"));
	switch (action) {
		case documentBpActions.activitiprocessAccreditationCA:
		case documentBpActions.completeCounterpartyCorrections: message = i18n.t("documentSuccessfullySentToWork"); break;
		case documentBpActions.activitiProcessDocCA:
		case documentBpActions.activiti$processInvoice:
		case documentBpActions.activiti$completeContractsSigning: message = i18n.t("documentSuccessfullySent"); break;
		case documentBpActions.activiti$returnContractToCorrections: message = i18n.t("documentSuccessfullySentToRevision"); break;
		default: message = i18n.t("documentSuccessfullySaved");
	}
	await executeSubmitRequest(this.state, action, getFormFields.bind(this)()).then(async (response) => {
		if (response.status === 422) require('../ModalDialog').errorMessageDialog(i18n.t("4"));
		else if (!response.ok) handleGetDocumentError(response.status);
		else {
			const data = await response.json();

			if (prop_sys_node_uuid) {
				let dialogTitle = i18n.t("done");
				
				if (!data.checkResult.success) {
					dialogTitle = i18n.t("error");
					message = data.checkResult.errorMessage;
				}
				ModalDialogsTemplates.messageDialog(dialogTitle, message, async () => document.location.replace(`/content/${prop_sys_node_uuid}` + document.location.search));
			}
			else {
				ModalDialogsTemplates.messageDialog(i18n.t("done"), message, async () => document.location.replace(`/content/${data.nodeRef.split('/').pop()}` + document.location.search));
			}
		}
	});
}
export async function executeSubmitRequest(state, action, formFields) {
	const { prop_sys_node_uuid, parent, type, file, comments, addedContractId, associations, dateLoaded, attachments, cpAuthorityPersons, removedSignatories } = state;
	const currentCompany = HelperFunctions.getCurrentCompany();

	let contractNodeRef = null;
	if (parent) contractNodeRef = `workspace://SpacesStore/${parent}`;
	else if (addedContractId) contractNodeRef = `workspace://SpacesStore/${addedContractId}`;
	else if (associations?.universalContractDoc?.length > 0) contractNodeRef = associations.universalContractDoc[0];

	return await fetch(`Document/${prop_sys_node_uuid ? "Edit" : "Add"}/${prop_sys_node_uuid ?? ''}${action ? `?actionDoc=${action}` : ""}`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			properties: JSON.stringify(clearUnusedFields(formFields, type)),
			comments, content: file ? {
				properties: { title: file.name },
				data: file ? (await HelperFunctions.getBase64(file, false))?.content : null
			} : {},
			contractNodeRef: contractNodeRef,
			counterpartyNodeRef: currentCompany ? `workspace://SpacesStore/${currentCompany.id}` : null,
			type,
			dateLoaded,
			addedFiles: attachments?.filter(a => a.isNew),
			addedSignatories: cpAuthorityPersons.filter(s => s.added),
			updatedSignatories: cpAuthorityPersons.filter(s => !s.added && s.updated),
			removedSignatories
		})
	})
		.then((response) => {
			return response;
		});
}
export async function addAdditionaSignatory(id, type) {
	this.state.assoc_sxcfc_externalSigners_added = id;
	this.actionHandlerCallback(actionTypes.save, type);
}

function clearUnusedFields(formFields, type) {
	switch (type) {
		case alfrescoTypes.counterpartyDoc:
			if (formFields.prop_sx_caDocKind !== counterpartyDocKinds.guaranteeLetters && formFields.prop_sx_caDocKind !== counterpartyDocKinds.supportingDocuments) {
				formFields.prop_sx_caDocMouth = '';
			}
			break;
	}
	return formFields;
}

async function addMainContract(type, rows = []) {
	if (rows.length > 0) {
		this.setState({
			addedContractId: rows[0].columns.Id
		});
	}
}
function getContractContent(ids, canEdit = false) {
	const { formMode, addedContractId, associations, type } = this.state;
	const contractIds = addedContractId ? [addedContractId] : (associations?.universalContractDoc?.length > 0 ? [associations.universalContractDoc[0]] : ids);
	const editTitle = contractIds?.length > 0 ? i18n.t("changeContract") : i18n.t("addContract");

	return [
		contractIds?.length > 0 &&
		<ListOfAlfresco actionsForAll={clientSettings.table.MainContent.actions.filter(i =>
			i.modes.includes(formModes.all) || i.modes.includes(formMode))}
			actionHandlerCallback={mainContractActionHandler.bind(this)}
			columns={["DocumentNumber", "DateDocument", "Kind"]}
			showPagination={false} showFilter={false}
			parentComponent={ListOfContracts}
			type={searchTableTypes.Documents}
			withAction={false}
			additionalFilter={JSON.parse(JSON.stringify({
				"Id":
					contractIds.map(id => id.split('/').pop())
			}))} />,
		canEdit && <div className="form-group form-group__last">
			{formMode !== formModes.read && (type !== alfrescoTypes.counterpartyDoc || formMode === formModes.create) ?
				<button type="button" onClick={() => ModalDialog.showModalDialog('modalDialog', editTitle, "",
					<ListOfAlfresco
						saveApi={`Table/Save?searchTableTypes=${searchTableTypes.Documents}`}
						withAction={false}
						parentComponent={ListOfContracts}
						type={searchTableTypes.Documents}
						additionalFilter={{ "SearchType": [alfrescoTypes.universalContract], "Kind": ["C33", "A40101"] }}
						actionHandlerCallback={addMainContract.bind(this)}
						singleSelect={true}
						autoSelect={true}
					/>, "feedPopup agreement middle-size")}
					className="btn btn-secondary">
					{editTitle}
				</button> :
				(!contractIds || contractIds?.length === 0) &&
				<div className="col-lg-12"><label>{i18n.t("contractNotSelected")}</label></div>
			}
		</div>
	];
}
export function renderAttachments() {
	const { formMode, associations, prop_cm_title, file, type, parent, prop_sx_caDocKind, attachments, externalSigners } = this.state;

	let addMainFile = (e) => {
		if (ModalDialogsTemplates.isAllowedFileTypeDialog(e.target.files[0], allowedAdditionalFileExtensions) && ModalDialogsTemplates.isValidFileSizeDialog(e.target.files[0].size)) {
			ModalDialogsTemplates.messageDialog(i18n.t("done"), i18n.t('30'));
			this.setState({ file: e.target.files[0] });
		}
	}

	let addAdditionalFile = async (e) => {
		if (ModalDialogsTemplates.isAllowedFileTypeDialog(e.target.files[0], allowedAdditionalFileExtensions) && ModalDialogsTemplates.isValidFileSizeDialog(e.target.files[0].size)) {
			const additionalFiles = attachments ?? [];
			const name = e.target.files[0].name;
			const type = e.target.files[0].type;
			let base64File = await HelperFunctions.getBase64(e.target.files[0]);
			additionalFiles.push({
				isNew: true,
				nodeRef: v4(),
				content: base64File.content,
				fileName: name,
				mimeType: type,
				title: name
			});
			this.setState({ attachments: additionalFiles });

			ModalDialogsTemplates.messageDialog(i18n.t("done"), i18n.t('fileSuccessfullyAdded'));
		}
	}


	const mainContent = associations?.mainContent;
	let items = [];

	if (type === alfrescoTypes.counterpartyDoc) {
		if (prop_sx_caDocKind === 'Doc_C33') {
			items.push({
				title: i18n.t('29'),
				className: 'required',
				content: getContractContent.bind(this)(associations?.contract, true)
			});
		}
	}
	else {
		if (associations?.contracts?.length > 0) {
			items.push({
				title: i18n.t('27'),
				className: 'required',
				content: getContractContent.bind(this)(associations.contracts)
			});
		}
		if (associations?.contract?.length > 0) {
			items.push({
				title: i18n.t('29'),
				className: 'required',
				content: getContractContent.bind(this)(associations.contract)
			});
		}
		else if (parent) {
			items.push({
				title: i18n.t('29'),
				className: 'required',
				content: getContractContent.bind(this)([parent])
			});
		}

		if (associations?.invoice?.length > 0) {
			items.push({
				title: i18n.t('28'),
				className: 'required',
				content: getContractContent.bind(this)(associations.invoice)
			});
		}
	}

	let mainFileIsPdf = file ? (/.?\.pdf$/i).test(file.name): true;
	items.push({
		title: i18n.t('attachedFiles'),
		subTitle: i18n.t('mainDocumentFile'),
		className: 'required',
		content:
			<>
				<Table columns={clientSettings.table.MainContent.columns}
					actionHandlerCallback={mainAttachedFileActionHandler.bind(this)}
					actionsForAll={clientSettings.table.MainContent.actions.filter(i =>
						(i.modes.includes(formModes.all) || i.modes.includes(formMode))
						&& (i.type !== actionTypes.previewFile || mainFileIsPdf))
					}
					items={file || mainContent?.length > 0 ?
						[{
							columns: {
								Id: mainContent?.length > 0 ? mainContent[0] : v4(), FileName: prop_cm_title ?? i18n.t(`form.${type.replace(':', '_')}.title`)
							}
						}] :
						[]}
				/>
				{formMode !== formModes.read &&
					[v4()].map(item => (<>
						<button onClick={() =>
							document.getElementById(item).click()
						} type="button" className="btn btn-primary">
							{file || mainContent?.length > 0 ? i18n.t('changeDocumentFile') : i18n.t('addDocumentFile')}
						</button>
						<input name="file" id={item} accept={acceptAdditionalInputFileString}
							onChange={addMainFile.bind(this)} type="file" style={{ display: "none" }}
						/>
					</>))
				}
			</>
	});
	if (type === alfrescoTypes.counterpartyDoc) {
		items.push({
			subTitle: i18n.t('additionalFiles'),
			content:
				<>
					<Table columns={clientSettings.table.AdditionalFiles.columns}
						actionHandlerCallback={attachedFilesActionHandler.bind(this)}
						items={attachments?.map(item => ({
							columns: {
								Id: item.nodeRef,
								FileName: item.title
							},
							actions: clientSettings.table.AdditionalFiles.actions.filter(i =>
								(i.modes.includes(formModes.all) || i.modes.includes(formMode)) &&
								(i.type !== actionTypes.previewFile || item.title.toLowerCase().endsWith('.pdf') || !item.isNew) &&
								((i.type !== actionTypes.downloadWithSignVisualization && i.type !== actionTypes.downloadSigns) || (externalSigners?.length > 0 && !item.isNew)))
						}))}
					/>
					{formMode !== formModes.read &&
						[v4()].map(item => (<>
							<button onClick={() =>
								document.getElementById(item).click()
							} type="button" className="btn btn-primary">
								{i18n.t('addFile')}
							</button>
							<input name="file" id={item} accept={acceptAdditionalInputFileString}
								onChange={addAdditionalFile.bind(this)} type="file" style={{ display: "none" }}
							/>
						</>))
					}
				</>
		});
	}
	return (items.map((v, k) => <div key={k}>
		{v?.content && v.title &&
			<div className="col-lg-12">
				<label className="table-label">{v.title}</label>
			</div>
		}
		<div className="col-lg-12">
			{v.subTitle &&
				<label className={v.className}>{v.subTitle}</label>
			}
			{v?.content}
		</div>
	</div>));
}
export function mainContractActionHandler(actionType, rows) {
	ListOfDocuments.actionHandlerCallback(actionType, [rows[0].columns.Id]);
}
export async function mainAttachedFileActionHandler(actionType, ids) {
	const { associations, file } = this.state;
	switch (actionType) {
		case actionTypes.download:
			if (file) {
				let fileName = file.name;
				let fileNameParts = fileName.split('.');
				if (fileNameParts.length > 1) {
					fileNameParts.pop();
					fileName = fileNameParts.join('.');
				}
					
				const fileData = {
					fileName: fileName,
					mimeType: file.type,
					content: (await HelperFunctions.getBase64(file, false)).content
				}
				downloadContent(fileData);
			}
			else if (associations?.mainContent) {
				ListOfDocuments.actionHandlerCallback(actionType, ids);
			}
			break;
		case actionTypes.previewFile:
			if (file) {
				let base64 = (await HelperFunctions.getBase64(file, false)).content;
				let objectUrl = window.URL.createObjectURL(HelperFunctions.base64toBlob(base64, "application/pdf"))
				ModalDialog.viewFile(objectUrl, file.name)
			}
			else if (associations?.mainContent) {
				ListOfDocuments.actionHandlerCallback(actionType, ids);
			}
			break;
		default:
			ListOfDocuments.actionHandlerCallback(actionType, ids);
			break;
	}
}

export async function attachedFilesActionHandler(actionType, ids) {
	const { attachments, removedDocuments } = this.state;
	switch (actionType) {
		case actionTypes.download:
			if (attachments?.length > 0) {
				let newDocuments = attachments.filter(a => ids.includes(a.nodeRef) && a.isNew);
				let oldDocuments = attachments.filter(a => ids.includes(a.nodeRef) && !a.isNew);
				if (newDocuments.length > 0) {
					newDocuments.forEach(doc => {
						downloadContent(doc);
					});
					
				}
				if (oldDocuments.length > 0) {
					ListOfDocuments.actionHandlerCallback(actionType, oldDocuments.map(doc => doc.nodeRef));
				}
			}
			break;
		case actionTypes.downloadWithSignVisualization: {
			if (attachments?.length > 0) {
				let documents = attachments.filter(a => ids.includes(a.nodeRef) && !a.isNew);
				if (documents.length > 0) {
					const results = await Promise.all(documents.map(doc => downloadFile(doc.nodeRef, doc.title, "", false, true)));
					if (!results.some(r => r === true)) {
						ModalDialog.showModalDialog("modalDialog", i18n.t("loadingDocuments"), "",
							<div className="info-message">{i18n.t("loadedDocumentNotFound")}</div>,
							"feedPopup", true,
							[{ title: i18n.t("ok"), clickHandler: () => ModalDialog.hideModalDialog('modalDialog'), class: "btn-primary" }]);
					}
				}
			}
			break;
		}
		case actionTypes.downloadSigns: {
			if (attachments?.length > 0) {
				let documents = attachments.filter(a => ids.includes(a.nodeRef) && !a.isNew);
				if (documents.length > 0) {
					const results = await Promise.all(documents.map(doc => downloadSign(doc.nodeRef, doc.title)));
					if (!results.some(r => r === true)) {
						ModalDialog.showModalDialog("modalDialog", i18n.t("loadingDocuments"), "",
							<div className="info-message">{i18n.t("loadedDocumentNotFound")}</div>,
							"feedPopup", true,
							[{ title: i18n.t("ok"), clickHandler: () => ModalDialog.hideModalDialog('modalDialog'), class: "btn-primary" }]);
					}
				}
			}
			break;
		}
		case actionTypes.previewFile: {
			let document = attachments.find(a => a.nodeRef === ids[0] && a.isNew);
			if (document) {
				let objectUrl = window.URL.createObjectURL(HelperFunctions.base64toBlob(document.content, "application/pdf"))
				ModalDialog.viewFile(objectUrl, document.title)
			}
			else {
				ListOfDocuments.actionHandlerCallback(actionType, ids);
			}
			break;
		}
		case actionTypes.remove: {
			let closeDialog = () => ModalDialog.hideModalDialog('modalDialog');
			let confirmDialog = () => {
				closeDialog();
				const removedAttachments = attachments.filter(a => ids.includes(a.nodeRef));
				const oldDocs = removedAttachments.filter(a => !a.isNew);

				let removed = removedDocuments;

				if (oldDocs.length > 0) {
					if (!removed) {
						removed = [];
					}
					removed.push(oldDocs.map(d => d.nodeRef));
				}
				this.setState({
					attachments: attachments.filter(a => !ids.includes(a.nodeRef)),
					removedDocuments: removed
				}, () => {
					globalEventDispatcher.dispatch(dispatcherActionTypes.onUnselectTableAllRows);
				});
			}

			ModalDialog.showModalDialog("modalDialog", i18n.t("removing"), "", <div className="info-message">{i18n.t("removeDocumentsMessage")}</div>,
				"feedPopup", true, [{ title: i18n.t("yes"), clickHandler: confirmDialog, class: "btn-primary" },
					{ title: i18n.t("no"), clickHandler: closeDialog, class: "btn-secondary" }]);
			break;
		}
		default:
			ListOfDocuments.actionHandlerCallback(actionType, ids);
			break;
	}
}

export async function getFilesContentForSigning(ids, ignoreErrors = false) {
	let fielesContent = [];
	let requestOptions = { method: 'post', headers: { 'Content-Type': 'application/json' } };
	for (let i = 0; i < ids.length; ++i) {
		const response = await fetch(`file/GetFileHash?id=${ids[i]}`, requestOptions);
		if (response.ok) {
			fielesContent.push({ id: ids[i], value: await response.text() });
		}
		else if (!ignoreErrors) return false;
	}
	return fielesContent;
}

export async function checkActionPermission(permissionType) {
	const { prop_sys_node_uuid, dateLoaded } = this.state;
	let result = await fetch(`Document/CheckActionPermission?id=${prop_sys_node_uuid}&permissionType=${permissionType}&loadedDate=${dateLoaded}`, { method: "GET" })
		.then(async (res) => {
			const data = await res.json();
			let modalCloseFunction = async function () {
				window.onbeforeunload = null;
				document.location.replace(`/content/${prop_sys_node_uuid}`);
			}
			if (!data.success) {
				ModalDialogsTemplates.messageDialog(i18n.t("error"), data.errorMessage, () => modalCloseFunction());
			}
			return data.success;
		});
	return result;
}